import React from 'react'
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavLink from '../components/NavLink';

const DevelopersSidebar = ({ onMenuItemClick }) => {

  return (
    <div className="sidebar-container-alt">
      <div className="scrollbar">
        <Nav className="flex-column">
          <Nav.Link as={ NavLink } eventKey="go-dashboard" to="/app/dashboard" className="go-to-dashboard" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['fas', 'arrow-left'] } className="mr-2" />
            <span className="nav-link-text">
              Dashboard
            </span>
          </Nav.Link>

          <Nav.Link eventKey="disabled" disabled className="divider-simple">

          </Nav.Link>
          <Nav.Link eventKey="disabled" disabled className="divider">
            Requests
          </Nav.Link>

          <Nav.Link as={ NavLink } eventKey="timbrado-facturas" to="/developers/timbrado/comprobantes" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['far', 'circle'] } className="dot-icon" />
            <span className="nav-link-text">Facturas</span>
          </Nav.Link>

          <Nav.Link as={ NavLink } eventKey="timbrado-retenciones" to="/developers/timbrado/retenciones" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['far', 'circle'] } className="dot-icon" />
            <span className="nav-link-text">Retenciones</span>
          </Nav.Link>

          <Nav.Link eventKey="disabled" disabled className="divider">
            Audits
          </Nav.Link>

          <Nav.Link as={ NavLink } eventKey="app-logs" to="/developers/audits/app-logs" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['far', 'circle'] } className="dot-icon" />
            <span className="nav-link-text">App Logs</span>
          </Nav.Link>

          <Nav.Link as={ NavLink } eventKey="system-logs" to="/developers/audits/system-logs" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['far', 'circle'] } className="dot-icon" />
            <span className="nav-link-text">System Logs</span>
          </Nav.Link>

        </Nav>
      </div>
    </div>
  )
}

export default DevelopersSidebar
